import classNames from "classnames";
import { Chip, ChipUIProps } from "../Chip/Chip";

export interface ChipProp {
  id: string;
  key: string;
  isSelected: boolean;
}

interface MultiSelectChipsProps {
  chips: ChipProp[];
  onSelect: (chip: ChipProp) => void;
  className?: string;
  chipProps?: ChipUIProps;
  selectedChipProps?: ChipUIProps;
}

export const MultiSelectChips = ({ chips, onSelect, className, chipProps, selectedChipProps }: MultiSelectChipsProps) => {
  const props = (selected: boolean) => (selected ? selectedChipProps : chipProps);

  return (
    <div data-testid="multi-select-chips" className={classNames("flex flex-wrap gap-4", className)}>
      {chips.map((chip) => (
        <Chip
          key={chip.id}
          text={chip.key}
          onClick={() => onSelect(chip)}
          theme={chip.isSelected ? "secondary" : "grey"}
          {...props(chip.isSelected)}
        />
      ))}
    </div>
  );
};
